import { Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getFormItems } from '../../../../../redux/forms/actions';
import styles from './CorporateClientForm.module.scss';
import AddressAutocomplete from '../../../../addressAutocomplete/AddressAutocomplete';
import {
	checkForValueInJson,
	checkEmptyRequiredFields,
} from '../../../../../utils/checkForValueInJson';
import { allowOnlyNumbeAndSpace } from '../../../../../utils/validateForm';
import _ from 'lodash';
import CustomTextField from '../../../../layout/customTextField/CustomTextField';

const CorporateClientForm = ({
	// parent props
	corporationInfoData,
	setCorporationInfoData,
	corporationError,
	setCorporationError,
	tab,
	handleSaveClientInfo,
	// redux
	getFormItems,
	formFields,
	corporationData,
}) => {
	const address_inputs = formFields?.address;
	const inputs = formFields?.corporation;

	useEffect(() => {
		getFormItems('agreement', 'clientInfo');
	}, []);

	useEffect(() => {
		setCorporationError({});
	}, [tab]);

	useEffect(() => {
		if (corporationData) {
			setCorporationInfoData(corporationData);
		} else {
			let inputFormData = inputs?.formData;
			let addressFormData = address_inputs?.formData;
			if (inputFormData && addressFormData) {
				let combinedForm = Object.assign(
					inputs.formData,
					address_inputs.formData
				);
				setCorporationInfoData(combinedForm);
			}
		}
	}, [corporationData, formFields]);

	const onChange = (e) => {
		let value = e.target.value;
		let name = e.target.name;
		if (value === '') {
			setCorporationError({ ...corporationError, [name]: true });
		} else {
			corporationError && delete corporationError[name];
		}

		if (name !== 'registrationNumber' || allowOnlyNumbeAndSpace(value)) {
			setCorporationInfoData({
				...corporationInfoData,
				[name]: value,
			});
		}
	};

	const saveFormData = (e) => {
		e.preventDefault();

		// 1-1. Empty check
		let chkFields = checkEmptyRequiredFields(
			corporationInfoData,
			inputs?.fields
		);
		let checkAddressFields = checkEmptyRequiredFields(
			corporationInfoData,
			address_inputs?.fields
		);

		// 1-2. Format check
		let combinedErr = Object.assign(
			chkFields,
			checkAddressFields,
			corporationError
		);
		setCorporationError(combinedErr);

		// 2. Validate -> send client info to db
		if (
			_.isEmpty(combinedErr) === true &&
			_.isEmpty(corporationError) === true &&
			checkForValueInJson(corporationError, true) !== true
		) {
			handleSaveClientInfo(true);
			// alert(JSON.stringify(corporationInfoData));
		}
	};

	return (
		<form
			id='client-details-form'
			onSubmit={(e) => saveFormData(e)}
			className={styles.client_form}
			method='POST'
			noValidate
		>
			<Grid container spacing={1}>
				{corporationInfoData && (
					<>
						<Grid item xs={12} sm={6}>
							{inputs?.fields?.map((field, index) => (
								<div
									className={styles.textField_item}
									key={index}
								>
									<CustomTextField
										formLabel={field?.formLabel}
										name={field?.formName}
										value={
											corporationInfoData[field?.formName]
										}
										onChange={(e) =>
											onChange(
												e,
												field?.formType,
												field?.formName
											)
										}
										type={field?.formType}
										error={
											corporationError &&
											corporationError[
												field?.formName
											] === true
												? true
												: false
										}
										required={
											field?.required === true
												? true
												: false
										}
										placeholder={field?.formLabel}
										autoComplete='off'
										errorMessage={field?.errorMessage}
										inputProps={
											field?.formName ===
											'registrationNumber'
												? { min: 0 }
												: null
										}
									/>
								</div>
							))}
						</Grid>
						<Grid item xs={12} sm={6}>
							<AddressAutocomplete
								formData={corporationInfoData}
								setFormData={setCorporationInfoData}
								defaultData={corporationInfoData?.address1}
								onChange={(e) => onChange(e)}
								error={corporationError}
								setError={setCorporationError}
							/>
						</Grid>
					</>
				)}
			</Grid>
		</form>
	);
};

const mapStateToProps = (state) => ({
	formFields: state.forms.form?.clientInfo,
	corporationData: state.agreement.agreementById?.clientInfo?.corporation,
});

export default connect(mapStateToProps, { getFormItems })(CorporateClientForm);
